import React from 'react'
import { useSelector } from 'react-redux'
import { useCollection } from '../../../utility/hooks/useCollection'

export const Readonly = ({ name, label, containerClassname, collection = [] }) => {
    const { form } = useSelector(state => state)

    const nodeForm = useCollection().getCollectionNode(form, collection)
    const value = nodeForm?.[name] || ''

    return (
        <div className={containerClassname}>
            <label className="control-label text-left fw-bold">{label}</label>
            <p className="form-control-plaintext ">
                {value}
            </p>
        </div>
    )
}